import React from 'react';
import './NavBtn.css'
import { Link } from "react-router";

const NavBtn = (props) => {
    return ( 
        <Link to={props.LinkPath} className={props.NavBtnStyle}>
            <img src={props.NavIcon} alt="" />
            <p>{props.NavText}</p>
        </Link>
     );
}
 
export default NavBtn;